angular.module('TetherApp').controller('SweepstakesController', [
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    '$interval',
    '$mdToast',
    'Upload',
    'sweepstakesService',
    'sweepstakesPrizingService',
    '$mdDialog',
    'participantModalService',
    'modelLockService',
    function (
        $anchorScroll,
        $location,
        $window,
        $timeout,
        $interval,
        $mdToast,
        Upload,
        sweepstakesService,
        sweepstakesPrizingService,
        $mdDialog,
        participantModalService,
        modelLockService
    ) {
        let self = this;
        let redirectTo = '/experience/sweepstakes';

        self.isSubmitting = false;

        self.sweepstakesList = {};
        self.sweepstakes = {};
        self.sweepstakes.experience = {};
        self.sweepstakes.experience.is_visible_on_campaign_dashboard = true;
        self.sweepstakes.started_at = new Date();
        self.sweepstakes.started_at.setHours(0);
        self.sweepstakes.started_at.setMinutes(0);
        self.sweepstakes.started_at.setSeconds(0);
        self.sweepstakes.started_at_hour = 0;
        self.sweepstakes.started_at_minute = 0;
        self.sweepstakes.started_at_second = 0;
        self.sweepstakes.ended_at = new Date();
        self.sweepstakes.ended_at.setHours(0);
        self.sweepstakes.ended_at.setMinutes(0);
        self.sweepstakes.ended_at.setSeconds(0);
        self.sweepstakes.ended_at_hour = 11;
        self.sweepstakes.ended_at_minute = 59;
        self.sweepstakes.ended_at_second = 59;
        self.sweepstakes.visibility = 'public';
        self.sweepstakes.private_list = 'Private List';
        self.sweepstakes.limit_type = 'unlimited';
        self.sweepstakes.limit_count = 1;
        self.sweepstakes.limit_by = 0; // phone
        self.sweepstakes.entry_scheduling = 'daily';
        self.sweepstakes.has_language_gate = false;
        self.sweepstakes.tokens = [];
        self.editingTokens = {};
        self.sweepstakes.pages = [
            {
                'name': 'Home',
                'html': '',
            },
            {
                'name': 'Home FR',
                'html': '',
            },
            {
                'name': 'Entry',
                'html': '',
            },
            {
                'name': 'Entry FR',
                'html': '',
            },
            {
                'name': 'Register',
                'html': '',
            },
            {
                'name': 'Register FR',
                'html': '',
            },
            {
                'name': 'Login',
                'html': '',
            },
            {
                'name': 'Login FR',
                'html': '',
            },
            {
                'name': 'Coupon',
                'html': '',
            },
            {
                'name': 'Coupon FR',
                'html': '',
            },
            {
                'name': 'Profile',
                'html': '',
            },
            {
                'name': 'Profile FR',
                'html': '',
            },
            {
                'name': 'FAQ',
                'html': '',
            },
            {
                'name': 'FAQ FR',
                'html': '',
            },
            {
                'name': 'Alternative Entry',
                'html': '',
            },
            {
                'name': 'Alternative Entry FR',
                'html': '',
            },
            {
                'name': 'Terms',
                'html': '',
            },
            {
                'name': 'Terms FR',
                'html': '',
            },
            {
                'name': 'Privacy',
                'html': '',
            },
            {
                'name': 'Privacy FR',
                'html': '',
            },
            {
                'name': 'Closed',
                'html': '',
            },
            {
                'name': 'Closed FR',
                'html': '',
            },
            {
                'name': 'Opening Soon',
                'html': '',
            },
            {
                'name': 'Opening Soon FR',
                'html': '',
            },
            {
                'name': 'Confirmation',
                'html': '',
            },
            {
                'name': 'Confirmation FR',
                'html': '',
            },
            {
                'name': 'Access',
                'html': '',
            },
            {
                'name': 'Access FR',
                'html': '',
            },
            {
                'name': 'Authourize',
                'html': '',
            },
            {
                'name': 'Authourize FR',
                'html': '',
            },
            {
                'name': 'Winner',
                'html': '',
            },
            {
                'name': 'Winner FR',
                'html': '',
            },
            {
                'name': 'Prizes',
                'html': '',
            },
            {
                'name': 'Prizes FR',
                'html': '',
            },
            {
                'name': 'Language',
                'html': '',
            },
            {
                'name': 'Language FR',
                'html': '',
            },
            {
                'name': 'No Purchase PDF',
                'html': '',
            },
            {
                'name': 'No Purchase PDF FR',
                'html': '',
            },
            {
                'name': 'CSS',
                'html': '',
            }
        ];
        self.editingPages = {};
        self.sweepstakes.form_rules = [];
        self.formRulesArray = [
            'Entry',
            'Alternative Entry',
            'Claim',
            'Offline',
            'Register',
            'Profile',
            'Release Accepted'
        ];
        self.editingFormRules = [];
        self.newFormRule = {};
        self.limits = range(1, 100);
        self.hours = range(0, 23);
        self.minutes = range(0, 59);
        self.seconds = range(0, 59);
        self.currentPage = 1;
        self.isRedirect = false;

        // REPORTING
        self.stats = {};
        self.graph = {};
        self.reportingStartedAt = undefined;
        self.reportingEndedAt = undefined;

        self.winnerFrom = new Date();
        self.winnerFrom.setHours(0);
        self.winnerFrom.setMinutes(0);
        self.winnerFrom.setSeconds(0);
        self.winnerFromHour = 0;
        self.winnerFromMinute = 0;
        self.winnerTo = new Date();
        self.winnerTo.setHours(0);
        self.winnerTo.setMinutes(0);
        self.winnerTo.setSeconds(0);
        self.winnerToHour = 0;
        self.winnerToMinute = 0;
        self.selectedWinnerParticipants = [];
        self.winnerRules = [];
        self.prizePools = {};
        self.prizePool = undefined;
        self.prizeType = undefined;
        self.draws = {};

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        // START: FORM RULES
        self.areOptionsDisabled = false;

        self.checkForEnforcedRules = function (index) {
            if (self.newFormRule[index].field_name === 'g-recaptcha-response') {
                self.newFormRule[index].is_required = true;
                self.newFormRule[index].format = 'captcha';
                self.newFormRule[index].is_disabled = true;
                self.areOptionsDisabled = true;
            }
        };

        self.addToken = function () {
            self.newTokenErrors = {};

            if (! self.newToken.name) {
                self.newTokenErrors['name'] = 'The name field is required';
            }

            if (! self.newToken.key) {
                self.newTokenErrors['key'] = 'The key field is required';
            }

            if (! self.newToken.content) {
                self.newTokenErrors['content'] = 'The content field is required';
            }

            if (Object.keys(self.newTokenErrors).length === 0) {
                let tempToken = JSON.parse(JSON.stringify(self.newToken));

                self.sweepstakes.tokens.push(tempToken);

                self.newToken = {};
            }
        };

        self.removeToken = function (tokenIndex) {
            self.sweepstakes.tokens.splice(tokenIndex, 1);
        };

        self.isEditingToken = function (tokenIndex) {
            if (self.editingTokens[tokenIndex] === undefined) {
                self.editingTokens[tokenIndex] = {};
            }
            if (self.editingTokens[tokenIndex].isOpen === undefined) {
                self.editingTokens[tokenIndex].isOpen = true;
            } else {
                self.editingTokens[tokenIndex].isOpen = !self.editingTokens[tokenIndex].isOpen;
            }
        };

        self.addFormRule = function ($index, type) {
            // Copy object
            let tempFormRule = JSON.parse(JSON.stringify(self.newFormRule[$index]));

            // Set form rule type
            tempFormRule.type = type;

            // Set is required to string equivalent
            let isRequired = tempFormRule.is_required ? 'required' : 'nullable';

            // Create field rules string
            tempFormRule.field_rules = [isRequired, tempFormRule.format].join('|');

            // Remove no longer relevant properties
            delete tempFormRule.is_required;
            delete tempFormRule.format;

            // Add item to sweepstakes object
            self.sweepstakes.form_rules.push(tempFormRule);

            // Reset the form values
            self.newFormRule[$index] = {};
        };

        self.removeFormRule = function (currentFormRule) {
            self.sweepstakes.form_rules.forEach(function (formRule, key) {
                // if the passed form rule equals the current iteration
                // form rule, remove it from the array
                if (angular.equals(formRule, currentFormRule)) {
                    self.sweepstakes.form_rules.splice(key, 1);
                }
            });
        };

        self.formRuleForType = function (type) {
            let tempRules = [];

            self.sweepstakes.form_rules.forEach(function (formRule) {
                if (formRule.type == type) {
                    tempRules.push(formRule);
                }
            });

            return tempRules;
        };

        self.prettyFieldName = function (name) {
            return name.replace('_', ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        };

        self.prettyRules = function (name) {
            return name.replace('|', ', ')
                .replace(',FIXED_LINE_OR_MOBILE', '')
                .replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        };

        self.isEditingFormRule = function (index) {
            if (self.editingFormRules[index] == undefined) {
                self.editingFormRules[index] = true;
            } else {
                self.editingFormRules[index] = ! self.editingFormRules[index];
            }
        };
        // END: FORM RULES

        // START: UPLOAD QUESTIONS
        self.sweepstakes.uploaded_image_questions = [];
        self.newUploadedImageQuestion = { type : '' };
        self.newUploadedImageQuestionAnswer = '';
        self.existingUploadedImageQuestionAnswer = '';
        self.newUploadedImageQuestionField = '';
        self.existingUploadedImageQuestionField = '';
        self.isQuestionOpen = {};

        self.addUploadedImageQuestion = function (data) {
            // Copy object
            var tempUploadedImageQuestion = JSON.parse(JSON.stringify(self.newUploadedImageQuestion));

            // Add item to sweepstakes object
            self.sweepstakes.uploaded_image_questions.push(tempUploadedImageQuestion);

            // Reset the question values
            self.newUploadedImageQuestion = { type : '' };

            // console.log(self.sweepstakes.uploaded_image_questions);
        };

        self.removeUploadedImageQuestion = function (index) {
            self.sweepstakes.uploaded_image_questions.splice(index, 1);
        };

        self.addNewUploadedImageQuestionAnswer = function () {
            if (!self.newUploadedImageQuestion.hasOwnProperty('configuration')) {
                self.newUploadedImageQuestion.configuration = [];
            }
            self.newUploadedImageQuestion.configuration.push(self.newUploadedImageQuestionAnswer);
            self.newUploadedImageQuestionAnswer = '';
        };

        self.removeNewUploadedImageQuestionAnswer = function (index) {
            self.newUploadedImageQuestion.configuration.splice(index, 1);
        };

        self.addExistingUploadedImageQuestionAnswer = function (index) {
            if (!self.sweepstakes.uploaded_image_questions[index].hasOwnProperty('configuration')) {
                self.sweepstakes.uploaded_image_questions[index].configuration = [];
            }
            self.sweepstakes.uploaded_image_questions[index].configuration.push(self.existingUploadedImageQuestionAnswer);
            self.existingUploadedImageQuestionAnswer = '';
        };

        self.removeExistingUploadedImageQuestionAnswer = function (index, answerIndex) {
            self.sweepstakes.uploaded_image_questions[index].configuration.splice(answerIndex, 1);
        };

        self.addNewUploadedImageQuestionField = function () {
            if (!self.newUploadedImageQuestion.hasOwnProperty('configuration')) {
                self.newUploadedImageQuestion.configuration = [];
            }
            self.newUploadedImageQuestion.configuration.push({ type: 'text', name: self.newUploadedImageQuestionField });
            self.newUploadedImageQuestionField = '';
        };

        self.removeNewUploadedImageQuestionField = function (index) {
            self.newUploadedImageQuestion.configuration.splice(index, 1);
        };

        self.addExistingUploadedImageQuestionField = function (index) {
            if (!self.sweepstakes.uploaded_image_questions[index].hasOwnProperty('configuration')) {
                self.sweepstakes.uploaded_image_questions[index].configuration = [];
            }
            self.sweepstakes.uploaded_image_questions[index].configuration.push({ type: 'text', name: self.existingUploadedImageQuestionField });
            self.existingUploadedImageQuestionField = '';
        };

        self.removeExistingUploadedImageQuestionField = function (index, fieldIndex) {
            self.sweepstakes.uploaded_image_questions[index].configuration.splice(fieldIndex, 1);
        };

        self.toggleQuestionOpen = function (index) {
            self.isQuestionOpen[index] = !self.isQuestionOpen[index];
        };

        // END: UPLOAD QUESTIONS

        //START: INDEX SERVICE FUNCTIONS
        self.index = function (page) {
            self.currentPage = page;
            sweepstakesService.indexSweepstakes(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.sweepstakesList = data.data;
        };
        //END: INDEX SERVICE FUNCTIONS

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (unparsed) {
            data = JSON.parse(JSON.stringify(unparsed));

            self.currentSetPages = self.sweepstakes.pages;

            angular.forEach(self.sweepstakes.pages, function (currentPage, key) {
                hasCurrentPage = false;
                angular.forEach(data.pages, function (currentDataPage, key) {
                    if (currentDataPage.name == currentPage.name) {
                        hasCurrentPage = true;
                    }
                });
                if (! hasCurrentPage) {
                    data.pages.push(currentPage);
                }
            });

            data.has_sharing = (data.has_sharing == '1') ? true : false;
            data.has_language_gate = (data.has_language_gate == '1') ? true : false;
            data.has_optin = (data.has_optin == '1') ? true : false;
            data.has_separate_optin_message = (data.has_separate_optin_message == '1') ? true : false;
            data.is_secret_code_experience = (data.is_secret_code_experience == '1') ? true : false;
            data.requires_validation = (data.requires_validation == '1') ? true : false;
            data.has_login = (data.has_login == '1') ? true : false;
            data.has_language_gate = (data.has_language_gate == '1') ? true : false;
            data.has_per_household_check = (data.has_per_household_check == '1') ? true : false;
            data.started_at = new Date(data.started_at.replace(/-/g, "/"));
            data.ended_at = new Date(data.ended_at.replace(/-/g, "/"));

            angular.forEach(data.pages, function(currentLoadedPage) {
                angular.forEach(self.currentSetPages, function(currentSetPage, key) {
                    if(currentSetPage.name == currentLoadedPage.name) {
                        self.currentSetPages[key] = currentLoadedPage;
                    }
                });
            });

            data.pages = self.currentSetPages;

            self.sweepstakes = data;
            self.sweepstakes.skill_testing_question_code_timeout_seconds = data.skill_testing_question_code_timeout_seconds;
            self.sweepstakes.skill_testing_question_code_timeout_boolean = false;
            if (self.sweepstakes.skill_testing_question_code_timeout_seconds !== null
                && self.sweepstakes.skill_testing_question_code_timeout_seconds !== undefined) {
                self.sweepstakes.skill_testing_question_code_timeout_boolean = true;
                // Set hours
                self.sweepstakes.skill_testing_question_code_timeout_hours = Math.floor(self.sweepstakes.skill_testing_question_code_timeout_seconds / (60 * 60));
                // Remove hours from seconds
                self.sweepstakes.skill_testing_question_code_timeout_seconds = self.sweepstakes.skill_testing_question_code_timeout_seconds % (60 * 60);
                // Set minutes
                self.sweepstakes.skill_testing_question_code_timeout_minutes = Math.floor(self.sweepstakes.skill_testing_question_code_timeout_seconds / 60);
                // Remove minutes from seconds
                self.sweepstakes.skill_testing_question_code_timeout_seconds = self.sweepstakes.skill_testing_question_code_timeout_seconds % 60;
            }
            self.sweepstakes.started_at_hour = data.started_at.getHours();
            self.sweepstakes.started_at_minute = data.started_at.getMinutes();
            self.sweepstakes.started_at_second = data.started_at.getSeconds();
            self.sweepstakes.ended_at_hour = data.ended_at.getHours();
            self.sweepstakes.ended_at_minute = data.ended_at.getMinutes();
            self.sweepstakes.ended_at_second = data.ended_at.getSeconds();
            if (self.sweepstakes.private_list == null || self.sweepstakes.private_list == undefined) {
                self.sweepstakes.private_list = 'Private List';
            }
            if (self.sweepstakes.limit_count == null || self.sweepstakes.limit_count == undefined) {
                self.sweepstakes.limit_count = 1;
            }

            if (self.sweepstakes.awarded_prize_limit == null || self.sweepstakes.awarded_prize_limit == undefined) {
                self.sweepstakes.awarded_prize_limit = '';
            }

            if (! self.sweepstakes.hasOwnProperty('form_rules')) {
                self.sweepstakes.form_rules = [];
            }

            if (! self.sweepstakes.hasOwnProperty('uploaded_image_questions')) {
                self.sweepstakes.uploaded_image_questions = [];
            }

            if (data.hasOwnProperty('prize_pools')) {
                self.sweepstakes.prize_pools = data.prize_pools;
            }

            self.getExperienceLock();
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function (isRedirect) {
            if (!isRedirect === false) {
                self.isRedirect = true;
            }
            let tempSweeps = JSON.parse(JSON.stringify(self.sweepstakes));

            if (self.isSubmitting == false) {
                self.isSubmitting = true;

                tempSweeps.started_at = new Date(
                    self.sweepstakes.started_at.getFullYear(),
                    self.sweepstakes.started_at.getMonth(),
                    self.sweepstakes.started_at.getDate(),
                    self.sweepstakes.started_at_hour,
                    self.sweepstakes.started_at_minute,
                    self.sweepstakes.started_at_second
                );

                tempSweeps.ended_at = new Date(
                    self.sweepstakes.ended_at.getFullYear(),
                    self.sweepstakes.ended_at.getMonth(),
                    self.sweepstakes.ended_at.getDate(),
                    self.sweepstakes.ended_at_hour,
                    self.sweepstakes.ended_at_minute,
                    self.sweepstakes.ended_at_second
                );

                let timeoutHours = self.sweepstakes.skill_testing_question_code_timeout_hours;
                let timeoutMinutes = self.sweepstakes.skill_testing_question_code_timeout_minutes;
                let timeoutSeconds = self.sweepstakes.skill_testing_question_code_timeout_seconds;
                let timeoutSecondsUpdate = 0;

                if (timeoutSeconds !== undefined) {
                    timeoutSecondsUpdate = parseInt(timeoutSeconds);
                }
                if (timeoutMinutes !== undefined) {
                    timeoutSecondsUpdate += (parseInt(timeoutMinutes) * 60);
                }
                if (timeoutHours !== undefined) {
                    timeoutSecondsUpdate += (parseInt(timeoutHours) * 60 * 60);
                }
                timeoutSecondsUpdate = timeoutSecondsUpdate == 0 ? null : timeoutSecondsUpdate;

                tempSweeps.skill_testing_question_code_timeout_seconds = timeoutSecondsUpdate;

                sweepstakesService.storeSweepstakes(tempSweeps)
                    .then(onStore, onError);
            }
        };

        let onStore = function (data) {
            redirectToIndex();
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function (isRedirect) {
            if (!isRedirect === false) {
                self.isRedirect = true;
            }
            let tempSweeps = JSON.parse(JSON.stringify(self.sweepstakes));
            console.debug(tempSweeps);

            if (self.isSubmitting == false) {
                self.isSubmitting = true;
                tempSweeps.started_at = new Date(
                    self.sweepstakes.started_at.getFullYear(),
                    self.sweepstakes.started_at.getMonth(),
                    self.sweepstakes.started_at.getDate(),
                    self.sweepstakes.started_at_hour,
                    self.sweepstakes.started_at_minute,
                    self.sweepstakes.started_at_second
                );

                tempSweeps.ended_at = new Date(
                    self.sweepstakes.ended_at.getFullYear(),
                    self.sweepstakes.ended_at.getMonth(),
                    self.sweepstakes.ended_at.getDate(),
                    self.sweepstakes.ended_at_hour,
                    self.sweepstakes.ended_at_minute,
                    self.sweepstakes.ended_at_second
                );

                let timeoutHours = self.sweepstakes.skill_testing_question_code_timeout_hours;
                let timeoutMinutes = self.sweepstakes.skill_testing_question_code_timeout_minutes;
                let timeoutSeconds = self.sweepstakes.skill_testing_question_code_timeout_seconds;
                let timeoutSecondsUpdate = 0;

                if (timeoutSeconds !== undefined) {
                    timeoutSecondsUpdate = parseInt(timeoutSeconds);
                }
                if (timeoutMinutes !== undefined) {
                    timeoutSecondsUpdate += (parseInt(timeoutMinutes) * 60);
                }
                if (timeoutHours !== undefined) {
                    timeoutSecondsUpdate += (parseInt(timeoutHours) * 60 * 60);
                }
                timeoutSecondsUpdate = timeoutSecondsUpdate == 0 ? null : timeoutSecondsUpdate;

                tempSweeps.skill_testing_question_code_timeout_seconds = timeoutSecondsUpdate;

                sweepstakesService.updateSweepstakes(tempSweeps)
                    .then(onUpdate, onError);
            }
        };

        let onUpdate = function (data) {
            if (self.isRedirect) {       
                self.releaseExperienceLock();
                redirectToIndex();
            } else {
                self.extendExperienceLock();
                self.isSubmitting = false;
            }
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (sweepstakesId) {
            if ($window.confirm(self.deleteText.replace(':id', sweepstakesId))) {
                sweepstakesService.deleteSweepstakes(sweepstakesId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            redirectToIndex();
        };

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: SWEEPSTAKES PAGES FUNCTIONS
        self.isEditing = function (tetherId) {
            if (self.editingPages[tetherId] == undefined) {
                self.editingPages[tetherId] = {};
            }
            if (self.editingPages[tetherId].isOpen == undefined) {
                self.editingPages[tetherId].isOpen = true;
            } else {
                self.editingPages[tetherId].isOpen = !self.editingPages[tetherId].isOpen;
            }
        };
        //END: SWEEPSTAKES PAGES FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        self.scrollToTop = function () {
            $location.hash('top');
            $anchorScroll();
        };

        let onError = function (data) {
            self.isSubmitting = false;
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };
        //END: GENERAL SERVICE FUNCTIONS

        //START: SWEEPS WINNER DRAWING

        self.setPrizePoolId = function (event) {
            self.prizePool = self.prizePoolModel.id;
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;
            dCtrl.experienceId = self.modalControllerExperienceId;

            if (experienceId !== undefined) {
                dCtrl.parent.show(experienceId);
            }

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                // console.log('success');
            };

            let onError = function (data) {
                // console.log('error');
            };

        };

        self.winnerPopup = function(ev, experienceId) {
            self.modalControllerExperienceId = experienceId;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'winnerPopupController',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/partials/winner-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
        };

        self.drawWinners = function() {
            data = {};
            data.count = self.winnerCount;

            self.selectedWinnerParticipants = [];

            if (self.winnerFromHour != undefined && self.winnerFromHour != '') {
                self.winnerFromHour = parseInt(self.winnerFromHour);
                self.winnerFrom.setHours(self.winnerFromHour);
            }

            if (self.winnerFromMinute != undefined && self.winnerFromMinute != '') {
                self.winnerFromMinute = parseInt(self.winnerFromMinute);
                self.winnerFrom.setMinutes(self.winnerFromMinute);
            }

            if (self.winnerToHour != undefined && self.winnerToHour != '') {
                self.winnerToHour = parseInt(self.winnerToHour);
                self.winnerTo.setHours(self.winnerToHour);
            }

            if (self.winnerToMinute != undefined && self.winnerToMinute != '') {
                self.winnerToMinute = parseInt(self.winnerToMinute);
                self.winnerTo.setMinutes(self.winnerToMinute);
            }

            data.from = self.winnerFrom;
            data.to = self.winnerTo;
            data.rules = self.winnerRules;

            sweepstakesService.drawWinners(self.sweepstakes.experience.id, data)
                .then(onDrawWinners, onError);
        };

        let onDrawWinners = function (data) {
            self.participants = data;
            angular.forEach(self.participants, function(participant, key) {
                if(participant.data) {
                    participant.data = JSON.parse(participant.data);
                }
            });
        };

        self.selectAllWinners = function(){
            self.selectedWinnerParticipants = [];
            angular.forEach(self.participants, function(participant, key) {
                self.selectedWinnerParticipants.push(participant.id);
            });
        };

        self.redrawWinners = function(){
            data = {};
            data.count = self.selectedWinnerParticipants.length;

            if (self.winnerFromHour != undefined && self.winnerFromHour != '') {
                self.winnerFromHour = parseInt(self.winnerFromHour);
                self.winnerFrom.setHours(self.winnerFromHour);
            }

            if (self.winnerFromMinute != undefined && self.winnerFromMinute != '') {
                self.winnerFromMinute = parseInt(self.winnerFromMinute);
                self.winnerFrom.setMinutes(self.winnerFromMinute);
            }

            if (self.winnerToHour != undefined && self.winnerToHour != '') {
                self.winnerToHour = parseInt(self.winnerToHour);
                self.winnerTo.setHours(self.winnerToHour);
            }

            if (self.winnerToMinute != undefined && self.winnerToMinute != '') {
                self.winnerToMinute = parseInt(self.winnerToMinute);
                self.winnerTo.setMinutes(self.winnerToMinute);
            }

            data.from = self.winnerFrom;
            data.to = self.winnerTo;
            data.rules = self.winnerRules;

            sweepstakesService.drawWinners(self.sweepstakes.experience.id, data)
                .then(onRedrawWinners, onError);
        };

        let onRedrawWinners = function(data){
            participantsToKeep = [];

            angular.forEach(self.participants, function(participant, key) {
                if(self.selectedWinnerParticipants.indexOf(participant.id) === -1) {
                    participantsToKeep.push(participant);
                }
            });

            self.participants = participantsToKeep;

            self.selectedWinnerParticipants = [];

            tempParticipants = data;
            angular.forEach(tempParticipants, function(participant, key) {
                if(participant.data) {
                    participant.data = JSON.parse(participant.data);
                }
                self.participants.push(participant);
            });
        };

        self.confirmWinners = function() {
            self.confirmWinnersErrors = [];
            if (self.prizePool === undefined) {
                self.confirmWinnersErrors.push('You must select a prize pool');
            }

            if (self.confirmWinnersErrors.length === 0) {
                data = {};
                data.participantIds = [];
                data.prizePool = self.prizePool;
                if (self.prizeType !== undefined) {
                    data.prizeType = self.prizeType;
                }
                angular.forEach(self.selectedWinnerParticipants, function(value, key) {
                    data.participantIds.push(value);
                });

                sweepstakesService.confirmWinners(self.sweepstakes.experience.id, data)
                    .then(onConfirmWinners, onError);
            }
        };

        let onConfirmWinners = function (data) {
            participantsToKeep = [];

            angular.forEach(self.participants, function(participant, key) {
                if(self.selectedWinnerParticipants.indexOf(participant.id) === -1) {
                    participantsToKeep.push(participant);
                }
            });

            self.participants = participantsToKeep;

            self.selectedWinnerParticipants = [];
        };

        self.toggleWinnerSelection = function (participantId) {
            let idx = self.selectedWinnerParticipants.indexOf(participantId);

            if (idx > -1) {
                self.selectedWinnerParticipants.splice(idx, 1);
            } else {
                self.selectedWinnerParticipants.push(participantId);
            }
        };

        self.addWinnerRule = function () {
            newRule = {};
            newRule.key = self.winnerKey;
            newRule.value = self.winnerValue;

            self.winnerKey = null;
            self.winnerValue = null;

            self.winnerRules.push(newRule);
        };

        self.removeWinnerRule = function (index) {
            self.winnerRules.splice(index, 1);
        };

        self.getPrizePools = function() {
            sweepstakesService.getPrizePools(self.experienceId)
                .then(onGetPrizePools, onError);
        };

        let onGetPrizePools = function (data) {
            self.prizePools = data;
        };
        //END: SWEEPS WINNER DRAWING

        //START: REPORTING SECTION
        self.loadStats = function (sweepstakesId) {
            if (self.currentId == undefined) {
                self.currentId = sweepstakesId;
            }
            sweepstakesService.statsSweepstakes(self.currentId)
                .then(onStats, onError);
            // if (self.updateStats == undefined) {
            //     self.updateStats = $interval(self.loadStats, 2000);
            // }
            self.graphSweepstakes();
        };

        let onStats = function (data) {
            self.reportingStartedAt = data.started_at;
            self.reportingEndedAt = data.ended_at;
            self.stats = data.stats;
        };

        self.graphSweepstakes = function () {
            sweepstakesService.graphSweepstakes(self.currentId)
                .then(onGraphSweepstakes, onError);
        };

        let onGraphSweepstakes = function (data) {
            self.graph.name = 'Overview Graph';
            self.graph.data = data.data;
            self.graph.labels = data.labels;
            self.graph.series = data.series;
        };
        //END: REPORTING SECTION

        // START: OFFLINE
        self.entered_at = new Date();
        self.postmarked_at = new Date();
        self.received_at = new Date();
        self.participantPopup = function (ev, participantId) {
            participantModalService.getParticipantModal(ev, participantId);
        };
        // END: OFFLINE



        //START ENTRY VALIDATION SECTION
        self.entryForValidation = {};
        self.otherEntries = {};
        self.showIndex = 0;
        self.showValidationInstructions = true;
        self.showKicked = false;
        self.entryImageRotation = 0;
        self.rotationClass = '';
        self.showCompleteMessage = false;
        self.currentEntryImageIndex = 1;
        self.skip = 0;
        self.otherEntryImageRotation = 0;
        self.currentOtherEntryImageIndex = 1;

        self.lockTimeLeftDisplay = '--:--';
        self.lockTimeEndDisplay = '--:--';
        self.showPriorImageUseContainer = false;

        self.participantInfo = function(ev, participantId) {
            participantModalService.getParticipantModal(ev, participantId);
        };

        let countdown;
        let timer = function (seconds) {
            // clear any existing timers
            $interval.cancel(countdown);

            let then = Date.now() + seconds * 1000;
            displayTimeLife(seconds);
            displayEndTime(then);

            countdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                // check if we should stop it
                if (secondsLeft < 0) {
                    $interval.cancel(countdown);
                    self.lockTimeLeftDisplay = '0:00';
                    $window.location.href = '/experience/sweepstakes';
                } else {
                    // display it
                    displayTimeLife(secondsLeft);
                }
            }, 1000);
        }

        let displayTimeLife = function (seconds) {
            let minutes = Math.floor(seconds / 60);
            let remainderSeconds = seconds % 60;
            self.lockTimeLeftDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
        }

        let displayEndTime = function (timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            self.lockTimeEndDisplay = adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        }

        let startTimer = function (seconds) {
            timer(parseInt(seconds));
        }

        self.newEntryForValdation = function (experienceId, experienceParticipantId) {
            self.experienceParticipantId = experienceParticipantId;

            data = { showKicked: self.showKicked, skip: self.skip };
            if(!experienceParticipantId) {
                sweepstakesService.getNewEntryForValidation(experienceId, data)
                    .then(onNewEntryForValdation, onError);
            } else {
                sweepstakesService.getEntryForValidation(experienceId, experienceParticipantId)
                    .then(onNewEntryForValdation, onError);
            }
        };

        let onNewEntryForValdation = function (data) {
            if (data.hasOwnProperty('lock')
                && data.lock != null
                && data.lock.hasOwnProperty('seconds_left')
                && data.lock.seconds_left != null) {
                startTimer(data.lock.seconds_left);
            } else {
                $interval.cancel(countdown);
                self.lockTimeLeftDisplay = '--:--';
                self.lockTimeEndDisplay = '--:--';
            }

            if (data.hasOwnProperty('entry') && (data.entry !== null || data.entry !== undefined)) {
                self.currentEntryImageIndex = 1;
                self.entryForValidation = data.entry;

                self.maxImagesForCurrentEntry = 0;

                loop = true;

                self.maxImagesForCurrentEntry = 0;
                self.imageMd5Hashes = [];

                while (loop) {
                    if (self.entryForValidation && self.entryForValidation.hasOwnProperty("image_" + (self.maxImagesForCurrentEntry + 1))) {
                        currentImage = self.entryForValidation["image_" + (self.maxImagesForCurrentEntry + 1)];
                    }
                    if (currentImage === undefined || currentImage.length === 0) {
                        loop = false;
                    } else {
                        if(self.entryForValidation.hasOwnProperty("image_" + (self.maxImagesForCurrentEntry + 1) + '_md5')) {
                            if(self.entryForValidation["image_" + (self.maxImagesForCurrentEntry + 1) + '_md5'] != '' && self.entryForValidation["image_" + (self.maxImagesForCurrentEntry + 1) + '_md5'] != undefined && self.entryForValidation["image_" + (self.maxImagesForCurrentEntry + 1) + '_md5'] != null) {
                                self.imageMd5Hashes.push(self.entryForValidation["image_" + (self.maxImagesForCurrentEntry + 1) + '_md5']);
                            }
                        }
                        self.maxImagesForCurrentEntry++;
                    }
                }

                if( self.imageMd5Hashes === 0 ) {
                    sweepstakesService.getMatchingImages(self.imageMd5Hashes)
                        .then(onGetMatchingImages, onError);
                }


                self.entryImageUrl = self.entryForValidation.image_1.indexOf('https') != -1
                    ? self.entryForValidation.image_1
                    : self.entryForValidation.image_1.replace('https', 'http');
                self.otherEntries = data.otherEntries;
                self.nextEntryForValidation = data.nextEntry;
                self.nextOtherEntries = data.nextOtherEntries;
                if (self.nextOtherEntries != undefined
                    && self.nextOtherEntries != null
                    && typeof self.nextOtherEntries == 'object') {
                    self.nextOtherEntriesImageUrls = [];
                    self.nextOtherEntries.forEach(function (entry) {
                        let url = entry.image_1.replace('https', 'http');
                        self.nextOtherEntriesImageUrls.push(url);
                    });
                }
                self.entryForValidation.data = JSON.parse(self.entryForValidation.data);

                self.otherEntryImageCleanup();
            } else {
                self.showCompleteMessage = true;
                self.entryForValidation = false;
            }
        };

        let onGetMatchingImages = function (data) {
            self.showPriorImageUseContainer = false;
            self.priorImageData = [];

            if (!data.errors) {
                angular.forEach(data, function(hash){
                    self.showPriorImageUseContainer = true;

                    counter = 1;
                    while (counter <= self.maxImagesForCurrentEntry) {
                        if(self.entryForValidation.hasOwnProperty("image_" + counter + '_md5')){
                            if(self.entryForValidation["image_" + counter + '_md5'] == hash.md5) {
                                self.priorImageData.push(
                                    {
                                        "name" : "Image " + counter,
                                        "count" : hash.count
                                    }
                                );
                            }
                        }

                        counter++;
                    }

                });
            }

            //console.log(self.priorImageData);
        };

        self.submitEntryForValdation = function (experienceId, experienceParticipantId, status, reason) {
            if (self.currentId == undefined) {
                self.currentId = experienceId;
            }

            data = {
                experienceParticipantId: experienceParticipantId,
                status: status,
                reason: reason
            };

            sweepstakesService.postEntryForValidation(experienceId, data)
                .then(onSubmitEntryForValdation, onError);
        };

        let onSubmitEntryForValdation = function (data) {
            if (data.errors) {
                alert(data.errors[0]);
            } else {
                if(self.experienceParticipantId) {
                    self.showCompleteMessage = true;
                    self.entryForValidation = false;
                } else {
                    self.newEntryForValdation(self.currentId);
                }
            }
        };

        self.previousCurrentEntryImage = function () {
            self.currentEntryImageIndex--;
            self.entryImageRotation = 0;

            if(self.currentEntryImageIndex < 1) {
                self.currentEntryImageIndex = self.maxImagesForCurrentEntry;
            }

            self.entryImageUrl = self.entryForValidation["image_" + self.currentEntryImageIndex].indexOf('https') != -1
                ? self.entryForValidation["image_" + self.currentEntryImageIndex]
                : self.entryForValidation["image_" + self.currentEntryImageIndex].replace('https', 'http');
        };

        self.nextCurrentEntryImage = function () {
            self.currentEntryImageIndex++;
            self.entryImageRotation = 0;

            if(self.currentEntryImageIndex > self.maxImagesForCurrentEntry) {
                self.currentEntryImageIndex = 1;
            }

            self.entryImageUrl = self.entryForValidation["image_" + self.currentEntryImageIndex].indexOf('https') != -1
                ? self.entryForValidation["image_" + self.currentEntryImageIndex]
                : self.entryForValidation["image_" + self.currentEntryImageIndex].replace('https', 'http');
        };

        //FUNCTIONS FOR SCROLLING THROUGH OTHER ENTRY IMAGES
        self.previousOtherEntryImage = function () {
            self.currentOtherEntryImageIndex--;
            self.otherEntryImageRotation = 0;

            if(self.currentOtherEntryImageIndex < 1) {
                self.currentOtherEntryImageIndex = self.maxImagesForCurrentOtherEntry;
            }

            self.otherEntryImageUrl = self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].indexOf('https') != -1
                ? self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex]
                : self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].replace('https', 'http');
        };

        self.nextOtherEntryImage = function () {
            self.currentOtherEntryImageIndex++;
            self.otherEntryImageRotation = 0;

            if(self.currentOtherEntryImageIndex > self.maxImagesForCurrentOtherEntry) {
                self.currentOtherEntryImageIndex = 1;
            }

            self.otherEntryImageUrl = self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].indexOf('https') != -1
                ? self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex]
                : self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].replace('https', 'http');

        };
        //END FUNCTIONS FOR SCROLLING THROUGH OTHER ENTRY IMAGES

        self.otherEntryImageCleanup = function() {
            self.otherEntryImageRotation = 0;
            self.currentOtherEntryImageIndex = 1;

            loop = true;

            self.maxImagesForCurrentOtherEntry = 0;

            while (loop) {
                if (self.otherEntries[self.showIndex] && self.otherEntries[self.showIndex].hasOwnProperty("image_" + (self.maxImagesForCurrentOtherEntry + 1))) {
                    currentImage = self.otherEntries[self.showIndex]["image_" + (self.maxImagesForCurrentOtherEntry + 1)];
                }
                if (currentImage === undefined || currentImage.length === 0) {
                    loop = false;
                } else {
                    self.maxImagesForCurrentOtherEntry++;
                }
            }

            self.otherEntryImageUrl = self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].indexOf('https') != -1
                ? self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex]
                : self.otherEntries[self.showIndex]["image_" + self.currentOtherEntryImageIndex].replace('https', 'http');

        }

        self.showNextEntry = function () {
            if (self.showIndex + 1 > self.otherEntries.length - 1) {
                self.showIndex = 0;
            } else {
                self.showIndex++;
            }

            self.otherEntryImageCleanup();
        };

        self.showPreviousEntry = function () {
            if (self.showIndex - 1 < 0) {
                self.showIndex = self.otherEntries.length - 1;
            } else {
                self.showIndex--;
            }

            self.otherEntryImageCleanup();
        };

        self.showNextKickedEntry = function (experienceId) {
            self.skip++;
            self.newEntryForValdation(experienceId);
        };

        self.showPreviousKickedEntry = function (experienceId) {
            if(self.skip - 1 <= 0) {
                self.skip = 0;
            } else {
                self.skip--;
            }
            self.newEntryForValdation(experienceId);
        };

        self.toggleValidationInstructions = function () {
            self.showValidationInstructions = !self.showValidationInstructions;
        };

        self.getConfirmationModal = function(ev, experienceId, experienceParticipantId, status) {
            self.confirmationModalExperienceId = experienceId;
            self.confirmationModalExperienceParticipantId = experienceParticipantId;
            self.confirmationModalExperienceStatus = status;
            ConfirmationModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ConfirmationModalController,
                controllerAs: 'confirmationModalController',
                templateUrl: '/experience/sweepstakes/' + experienceId + '/partials/entry-validation-confirmation-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let ConfirmationModalController = function ($mdDialog, experienceId, experienceParticipantId, status) {
            let dCtrl = this;
            dCtrl.experienceId = self.confirmationModalExperienceId;
            dCtrl.experienceParticipantId = self.confirmationModalExperienceParticipantId;
            dCtrl.status = self.confirmationModalExperienceStatus;
            dCtrl.selectedReason = '';
            dCtrl.selectedReasons = {};
            dCtrl.validationReasons = {};
            dCtrl.reasonErrors = [];

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    validationReason.selected = false;
                });

                $mdDialog.cancel();
            };

            let init = function () {
            }();

            dCtrl.submitEntryForValdation = function () {
                let reason = '';
                let glue = '';
                dCtrl.reasonErrors = [];

                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    if(validationReason.selected) {
                        if(reason === '') {
                            glue = '';
                        } else {
                            glue = ',';
                        }
                        reason = reason + glue + validationReason.key;
                    }
                });

                // Error, invalid content, display error
                if (status !== 'valid' &&
                    (reason === undefined || reason == null || (typeof reason == 'string' && reason.trim().length === 0))) {
                    dCtrl.reasonErrors.push('A reason is required for submission');
                } else {
                    self.submitEntryForValdation(
                        dCtrl.experienceId,
                        dCtrl.experienceParticipantId,
                        dCtrl.status,
                        reason
                    );
                    dCtrl.cancel();
                }
            };

            dCtrl.addReason = function () {
                dCtrl.reasonErrors = [];
                if (dCtrl.selectedReason) {
                    angular.forEach(dCtrl.validationReasons, function(validationReason){
                        if(dCtrl.selectedReason == validationReason.key) {
                            validationReason.selected = true;
                        }
                    });
                }
            };

            dCtrl.removeReason = function (key) {
                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    if(key == validationReason.key) {
                        validationReason.selected = false;
                    }
                });
            };
        };

        self.rotate = function (direction) {
            self.entryImageRotation += (direction == 'left') ? 90 : -90;
        };

        //END ENTRY VALIDATION SECTION


        // START: PRIZING
        self.indexPrizePool = function (experienceId) {
            sweepstakesPrizingService.index(experienceId)
                .then(onPrizePoolIndex, onPrizePoolIndexError);
        };

        var onPrizePoolIndex = function (data) {
            self.prizePools = data;
        };

        var onPrizePoolIndexError = function (data) {
            // Error.
        };

        self.indexPrizeType = function (experienceId, poolId) {
            sweepstakesPrizingService.indexType(experienceId, poolId)
                .then(onPrizeTypeIndex, onPrizeTypeIndexError);
        };

        var onPrizeTypeIndex = function (data) {
            self.prizePool = data;
            if (data.hasOwnProperty('prize_types')) {
                self.prizeTypes = data.prize_types;
            }
        };

        var onPrizeTypeIndexError = function (data) {
            // Error.
        };

        var ModalCreatePrizePoolController = function ($mdDialog, experienceId, indexPrizePool) {
            var modalController = this;
            modalController.experienceId = self.modalCreatePrizePoolControllerExperienceId;
            modalController.indexPrizePool = self.modalCreatePrizePoolControllerIndexPrizePool;
            modalController.name;
            modalController.errors = {};

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.store = function () {
                sweepstakesPrizingService.store(modalController.experienceId, {
                    'name': modalController.name,
                    'is_testing': modalController.is_testing
                }).then(onStore, onStoreError);
            };

            var onStore = function (data) {
                modalController.cancel();
                modalController.indexPrizePool(modalController.experienceId);

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully created prize pool!</span>' +
                        '</md-toast>'
                });
            };

            var onStoreError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openCreatePrizePoolModal = function (ev, experienceId) {
            self.modalCreatePrizePoolControllerExperienceId = experienceId;
            self.modalCreatePrizePoolControllerIndexPrizePool = self.indexPrizePool;
            ModalCreatePrizePoolController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalCreatePrizePoolController,
                controllerAs: 'createPrizePoolController',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/prize-pool/modal-create',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        let ModalEditPrizePoolController = function ($mdDialog) {
            let modalController = this;
            modalController.experienceId = self.modalEditPrizePoolExperienceId;
            modalController.prizePool = self.modalEditPrizePoolPrizePool;
            modalController.errors = {};

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.update = function () {
                sweepstakesPrizingService.update(
                    modalController.experienceId,
                    modalController.prizePool.id,
                    { name: modalController.prizePool.name }
                ).then(onUpdate, onUpdateError);
            };

            var onUpdate = function (data) {
                modalController.cancel();

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully updated the prize pool!</span>' +
                        '</md-toast>'
                });
            };

            var onUpdateError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openEditPrizePoolModal = function (ev, experienceId, prizePool) {
            self.modalEditPrizePoolExperienceId = experienceId;
            self.modalEditPrizePoolPrizePool = prizePool;
            ModalEditPrizePoolController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalEditPrizePoolController,
                controllerAs: 'editPrizePoolController',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/prize-pool/modal-edit',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        var ModalCreatePrizeTypeController = function ($mdDialog) {
            var modalController = this;
            modalController.name;
            modalController.errors = {};
            modalController.experienceId = self.modalCreatePrizeTypeExperienceId;
            modalController.poolId = self.modalCreatePrizeTypePrizePoolId;
            modalController.indexPrizeType = self.modalCreatePrizeTypeIndexPrizeType;

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.storeType = function () {
                sweepstakesPrizingService
                    .storeType(modalController.experienceId, modalController.poolId, { 'name': modalController.name })
                    .then(onStoreType, onStoreTypeError);
            };

            var onStoreType = function (data) {
                modalController.cancel();
                modalController.indexPrizeType(modalController.experienceId, modalController.poolId);

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully created a prize type!</span>' +
                        '</md-toast>'
                });
            };

            var onStoreTypeError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openCreatePrizeTypeModal = function (ev, experienceId, poolId) {
            self.modalCreatePrizeTypeExperienceId = experienceId;
            self.modalCreatePrizeTypePrizePoolId = poolId;
            self.modalCreatePrizeTypeIndexPrizeType = self.indexPrizeType;
            ModalCreatePrizeTypeController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalCreatePrizeTypeController,
                controllerAs: 'createPrizeTypeController',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/prize-pool/prize-type/modal-create',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };
        // END: PRIZING

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sweepstakes.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sweepstakes.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sweepstakes.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                    .title('Would you like to extend experience lock?')
                    .textContent('User will be redirected to index page without saving when timer runs out.')
                    .ariaLabel('Timer Dialog')
                    .ok('Extend Lock')
                    .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
            };
        //END: EXPERIENCE EDIT TIMER
    }
]);
